import { render, staticRenderFns } from "./IngredientDetails.vue?vue&type=template&id=3eb2b480&scoped=true&"
import script from "./IngredientDetails.vue?vue&type=script&lang=js&"
export * from "./IngredientDetails.vue?vue&type=script&lang=js&"
import style0 from "./IngredientDetails.vue?vue&type=style&index=0&id=3eb2b480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb2b480",
  null
  
)

export default component.exports